import { ConfigScope } from '../types'
import type { ConfigIdFields } from '../types'
import { deriveConfigScope } from './deriveConfigScope'

export function buildConfigQuery(config: ConfigIdFields): string {
  const scope = deriveConfigScope(config)
  const params = new URLSearchParams()

  params.set('configKeys', config.configKey)

  switch (scope) {
    case ConfigScope.IspConfig:
      if (config.inventorySystemProfileCode) {
        params.set('inventorySystemProfileCodes', config.inventorySystemProfileCode)
      }
      break
    case ConfigScope.TenantConfig:
      if (config.tenantCode) {
        params.set('tenantCodes', config.tenantCode)
      }
      break
    case ConfigScope.TenantIspConfig:
      if (config.tenantCode) {
        params.set('tenantCodes', config.tenantCode)
      }
      if (config.inventorySystemProfileCode) {
        params.set('inventorySystemProfileCodes', config.inventorySystemProfileCode)
      }
      break
    case ConfigScope.TenantVenueConfig:
      if (config.tenantCode) {
        params.set('tenantCodes', config.tenantCode)
      }
      if (config.venueId) {
        params.set('venueIds', config.venueId)
      }
      break
  }

  return `/v1/tenant-configs?${params.toString()}`
}
